module.exports = __webpack_public_path__ + "img/zc.5a121188.png";